module.exports = __webpack_public_path__ + "img/line-chart-view.541ffb22.svg";